export default __webpack_public_path__ + "static/media/plain-sticker-c.0c11de16.png";